import styled from 'styled-components';

import { Code } from '@common/Code';
import { CircularProgress } from '@mui/material';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 61px);
  overflow: auto;
  width: 100%;

  code {
    text-align: left;
    background-color: transparent;
    line-height: 1.3;
    font-size: 2.2ch;
    width: auto;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface Props {
  file: {
    file: any;
    content_type: string;
  };
  isLoading: boolean;
}

export const CodePreview: React.FC<Props> = ({ file, isLoading }) => {
  if (isLoading) {
    return (
      <Container>
        <LoadingContainer>
          <CircularProgress size={30} thickness={3} />
        </LoadingContainer>
      </Container>
    );
  }

  if (!file) return null;

  return (
    <Container>
      <Code language='json' code={file.file} />
    </Container>
  );
};
